//表单中set form值  (input触发change事件时,给form赋值)
export function setInputValue(fromVal, currentID, currentVal) {
    for (var i in fromVal) {
        switch (currentID) {
            case i:
                fromVal[i] = currentVal;
                break;
        }
        if (i == currentID) {
            return false;
        }
    }
}

//校验手机号格式
export function validatorPhone(val) {
    const that = this;
    let regExp = /^([0-9]{3,4}\-)?[0-9]{7,8}$|^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/;
    return regExp.test(val)
}

// 禁止输入特殊符号
export function stripscript(value) {
    const that = this;
    let str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im;
    return str.test(value)
}

//校验邮箱格式
export function validatorMail(val) {
    const that = this;
    let regExp = /^\w+@[a-z0-9]+\.[a-z]{2,4}$/;
    return regExp.test(val)
}
// 密码强度校验

export function passwordSet(pasw) {
    const that = this;
    let pas = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{8,12}$/;
    return pas.test(pasw)
}
// 校验身份证格式
export function validateIdCard(idCard) {
    //15位和18位身份证号码的正则表达式
    var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
    //如果通过该验证，说明身份证格式正确，但准确性还需计算
    if (regIdCard.test(idCard)) {
        if (idCard.length == 18) {
            var idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //将前17位加权因子保存在数组里
            var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
            var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
            for (var i = 0; i < 17; i++) {
                idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
            }
            var idCardMod = idCardWiSum % 11;//计算出校验码所在数组的位置
            var idCardLast = idCard.substring(17);//得到最后一位身份证号码
            //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
            if (idCardMod == 2) {
                if (idCardLast == "X" || idCardLast == "x") {
                    return true;
                    //alert("恭喜通过验证啦！");
                } else {
                    return false;
                    //alert("身份证号码错误！");
                }
            } else {
                //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
                if (idCardLast == idCardY[idCardMod]) {
                    //alert("恭喜通过验证啦！");
                    return true;
                } else {
                    return false;
                    //alert("身份证号码错误！");
                }
            }
        }
    } else {
        //alert("身份证格式不正确!");
        return false;
    }
}

//日期格式化
export function formatTen(num) {
    return num > 9 ? (num + "") : ("0" + num);
}

export function formatDate(date) {
    // return date
    const that = this
    var date = new Date(date)
    var year = date.getFullYear()
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();
    return year + "-" + formatTen(month) + "-" + formatTen(day) + " " + formatTen(hour) + ":" + formatTen(minute) + ":" + formatTen(second);
}
// 打印专用
export function printFormatDate(date) {
    // return date
    const that = this
    var date = new Date(date)
    var year = date.getFullYear()
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();
    return year + formatTen(month) + formatTen(day) + formatTen(hour) + formatTen(minute) + formatTen(second);
}
export function formatDateNoDetails(date) {
    // return date
    const that = this;
    var date = new Date(date)
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();
    return year + "-" + formatTen(month) + "-" + formatTen(day);

}


// 截取文件后缀名 返回一个数组 第一项为后缀名 第二项为文件名 第三项为传入的全名
export function getSuffix(fileName) {
    // var fileName = '20190522163922.png';
    let first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
    let namelength = fileName.length;//取到文件名长度
    let suffix = fileName.substring(first + 1, namelength);//截取获得后缀名
    let name = fileName.substring(0, first);//截取获得后缀名
    if (!name) {
        name = suffix
    }
    return [suffix, name, fileName]
}
// 简单的深拷贝
export function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
};



// WEBPACK FOOTER //
// ./src/assets/js/auth.js